module.exports = __webpack_public_path__ + "FixelDisplay-ExtraBold-8a150a1525e202b2818e7b0026bf0bf0.woff2";